import './product-details.scss';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const productDetailPage = isProductDetailPage; // eslint-disable-line

        if (productDetailPage) {
            window.dataLayer.push({
                event: 'pdp_view',
                pagePath: window.location.pathname,
                eventCategory: 'product_detail_page',
                eventAction: 'pageview',
                eventLabel: window.location.pathname
            });

            console.info('GTM Push:', 'pdp_view', window.location.pathname);
        }
    }
});
